var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content", staticStyle: { "margin-top": "16px" } },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form clearfix",
                  attrs: {
                    inline: true,
                    model: _vm.searchForm,
                    size: "small",
                    "label-width": "64px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位编号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入职位编号" },
                        model: {
                          value: _vm.searchForm.positionCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "positionCode", $$v)
                          },
                          expression: "searchForm.positionCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位描述" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入职位描述" },
                        model: {
                          value: _vm.searchForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "remark", $$v)
                          },
                          expression: "searchForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入职位名称" },
                        model: {
                          value: _vm.searchForm.positionName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "positionName", $$v)
                          },
                          expression: "searchForm.positionName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { float: "right", "margin-right": "0" } },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "s-btn",
                            on: {
                              click: function ($event) {
                                return _vm.fetchData("search")
                              },
                            },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "r-btn",
                            on: {
                              click: function ($event) {
                                return _vm.fetchData("reset")
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _vm.parArray.indexOf("zwadd_oa") != -1
                ? _c(
                    "div",
                    {
                      staticClass: "title-btn-item",
                      on: {
                        click: function ($event) {
                          return _vm.add("0")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("div", { staticClass: "btn-l" }, [_vm._v("新增职位")]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("lb-table", {
            attrs: {
              column: _vm.column,
              data: _vm.tableData,
              pagination: "",
              total: _vm.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: _vm.title,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "elForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "职位编号", prop: "positionName" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "12",
                      placeholder: "请输入职位编号",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.positionName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "positionName", $$v)
                      },
                      expression: "form.positionName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "职位名称", prop: "positionCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "12",
                      placeholder: "请输入职位名称",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.positionCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "positionCode", $$v)
                      },
                      expression: "form.positionCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "职位描述", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "remark",
                    attrs: {
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: "20",
                      placeholder: "请输入职位描述",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.isConfirm,
            width: "268px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isConfirm = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#2F3030",
                "line-height": "22px",
                "text-align": "center",
                "margin-left": "12px",
              },
            },
            [_vm._v(" 是否确认删除该职位？")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.qDelete()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("数据列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }